module.exports = __webpack_public_path__ + "img/ipad1.9f7fcc29.png";